import React, { useEffect } from 'react';
import { Img } from './styles';
import { initializeHubspotWebInteractives } from 'utils/hubspot';

interface HubspotCardProps {
  hubspotId: string;
  href: string;
  imgSrc: string;
  imgAlt?: string;
}

const HubspotCard: React.FC<HubspotCardProps> = ({ hubspotId, href, imgSrc, imgAlt }) => {
  useEffect(() => {
    initializeHubspotWebInteractives();
  }, []);

  return (
    <div
      className={`hs-cta-embed hs-cta-simple-placeholder hs-cta-embed-${hubspotId}`}
      data-hubspot-wrapper-cta-id={hubspotId}
    >
      <a href={href} target="_blank" rel="noopener noreferrer">
        <Img
          alt={imgAlt || 'Logo'}
          loading="lazy"
          src={imgSrc}
          onError={(e) => {
            e.currentTarget.style.display = 'none';
          }}
        />
      </a>
    </div>
  );
};

export default HubspotCard;
